<!-- Edit & Unlock Buttons -->
<div class="unlock-actions-container" *ngIf="canShowEditUnlock">
	<div class="order-unlocked container-action" *ngIf="!orderInboxModel.locked">
		<div class="edit-order-button">
			<button tooltipStyleClass="custom-tooltip"
					[tooltipPosition]="tooltipPlacement"
					pTooltip="Lock Order"
					class="btn btn-sm cv-btn-light action-button"
					(click)="lockOrder()">

				<svg class="svg-lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 -40 448 782"><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-primary" d="M0 256C0 220.7 28.65 192 64 192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256z"/><path class="fa-secondary" d="M224 64C179.8 64 144 99.82 144 144V192H80V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H304V144C304 99.82 268.2 64 224 64z"/>
				</svg>
			</button>
		</div>
	</div>

	<div class="h-100 locked-by-me container-action"
		*ngIf="orderInboxModel && orderInboxModel.locked && orderInboxModel.lockedBy.id === userContext.id">

		<div class="locked-by-information float-left">
			<div class="label locked-by">
				<small class="locked-by-text">Locked by:</small>
				<small class="d-block">{{lockedByName}}</small>
			</div>
		</div>

		<button tooltipStyleClass="custom-tooltip"
				[tooltipPosition]="tooltipPlacement"
				pTooltip="Unlock Order"
				class="btn btn-sm cv-btn-light action-button"
				[disabled]="unlockingOrder"
				(click)="onUnLockOrder()">
				<svg class="svg-unlock" xmlns="http://www.w3.org/2000/svg" viewBox="0 -40 448 782"><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-primary" d="M0 256C0 220.7 28.65 192 64 192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256z"/><path class="fa-secondary" d="M224 64C179.8 64 144 99.82 144 144V192H80V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H304V144C304 99.82 268.2 64 224 64z"/>
				</svg>
		</button>
	</div>

	<div class="h-100 locked-by-other-user-can-unlock container-action"
		*ngIf="orderInboxModel.locked && orderInboxModel.lockedBy.id !== userContext.id && canForceUnlock">
		<div class="h-100 locked-by-information float-left">
			<div class="label locked-by">
				<small class="locked-by-text">Locked by:</small>
				<small class="d-block">{{lockedByName}}</small>
			</div>
		</div>

		<button class="btn btn-sm cv-btn-light action-button"
				[disabled]="unlockingOrder"
				tooltipStyleClass="custom-tooltip"
				[tooltipPosition]="tooltipPlacement"
				pTooltip="Unlock Order"
				(click)="onUnLockOrder(true)">
				<svg class="svg-unlock" xmlns="http://www.w3.org/2000/svg" viewBox="0 -40 448 782"><defs><style>.fa-secondary{opacity:.4}</style></defs><path class="fa-primary" d="M0 256C0 220.7 28.65 192 64 192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256z"/><path class="fa-secondary" d="M224 64C179.8 64 144 99.82 144 144V192H80V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H304V144C304 99.82 268.2 64 224 64z"/>
				</svg>
		</button>
	</div>

	<div class="h-100 locked-by-other-user container-action"
		*ngIf="orderInboxModel.locked && orderInboxModel.lockedBy.id !== userContext.id && !canForceUnlock">
		<div class="locked-by-information">
			<div class="label">
				<i class="fas fa-lock"></i>
				<small>Read Information Only</small>
			</div>
			<div class="label locked-by">
				<small class="locked-by-text">Locked by</small>
				<small>{{lockedByName}}</small>
			</div>
		</div>
	</div>

	<div class="separator"></div>
</div>
